import type{ ReactNode } from 'react';
import { Ghost, FolderOpen, MagnifyingGlass, HardDrives } from '@phosphor-icons/react';
import { Button } from './Button';
import { motion } from 'framer-motion';

export type EmptyStateType = 'search' | 'data' | 'files' | 'general';

interface EmptyStateProps {
  type?: EmptyStateType;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  icon?: ReactNode;
}

const getIconForType = (type: EmptyStateType) => {
  switch (type) {
    case 'search':
      return <MagnifyingGlass size={48} weight="duotone" className="text-secondary" />;
    case 'data':
      return <HardDrives size={48} weight="duotone" className="text-secondary" />;
    case 'files':
      return <FolderOpen size={48} weight="duotone" className="text-secondary" />;
    case 'general':
    default:
      return <Ghost size={48} weight="duotone" className="text-secondary" />;
  }
};

export function EmptyState({
  type = 'general',
  title,
  description,
  actionLabel,
  onAction,
  icon
}: EmptyStateProps) {
  return (
    <motion.div 
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      className="flex flex-col items-center justify-center py-20 px-6 text-center max-w-md mx-auto"
    >
      <div className="w-20 h-20 rounded-full bg-slate-100 flex items-center justify-center mb-6 shadow-sm border border-border">
        {icon || getIconForType(type)}
      </div>
      
      <h3 className="font-outfit font-extrabold text-xl text-primary mb-2">
        {title}
      </h3>
      
      <p className="text-sm text-secondary leading-relaxed mb-8">
        {description}
      </p>
      
      {actionLabel && onAction && (
        <Button onClick={onAction} variant="primary" className="px-6">
          {actionLabel}
        </Button>
      )}
    </motion.div>
  );
}
